import { Grid } from "@mui/material";
import { capitalizeWords } from "../../../../../utils/functions";
import { COMPONENT_SPACING } from "../../../../../utils/constants/designConstants";
import { MetricBox } from "../../../../ReusableComponents/MetricBox";

export const PFFMetricsSection = ({ porterFiveForces }) => {
  return (
    <Grid container spacing={COMPONENT_SPACING.GRID_SPACING} sx={{ my: 10 }}>
      {Object.entries(porterFiveForces.metrics).map(([metricsKey, value]) => {
        const score = value.value || 0;
        const label = value.label;
        const title = capitalizeWords(metricsKey.replace(/_/g, " "));

        return (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={metricsKey}>
            <MetricBox
              title={title}
              score={score}
              label={label}
              variant="dark"
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
